var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevisarNominaAltaImss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c7e3f9;}.cls-2{fill:#9a725f;}.cls-3{fill:#f3d585;}.cls-4{fill:#ce732f;}.cls-5{fill:#f4e0b6;}.cls-6{fill:#c3a998;}.cls-7{fill:#fff;}.cls-8{fill:#ccc;}.cls-9{fill:#603813;}.cls-10{fill:#faf49e;}.cls-11{fill:#c65550;}.cls-12{fill:#5172a1;}.cls-13{fill:#333;}.cls-14{fill:#7ac943;}.cls-15{fill:#7ab36e;}.cls-16{fill:#395c82;}.cls-17{fill:#e8b954;}.cls-18{fill:#c2fb3b;}.cls-19{fill:#9cdd05;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "revisar_nomina_alta_imss") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 72.5,
    cy: 72.5,
    r: 72.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.21,45.14H47.09L45,50H35.35l-2.07-4.84H20.15L26.37,21H54l6.22,24.17V61H20.15V45.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.2,23.73h18v7.32h-18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.4,27.19H34a.69.69,0,0,1,0-1.38H46.4a.69.69,0,1,1,0,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M29.13,30h22.1v6.94H29.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48.47,33.4H31.89a.69.69,0,1,1,0-1.38H48.47a.69.69,0,0,1,0,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.06,36.17H53.3v22.1H27.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M60.21,61H20.15V45.14H33.28L35.35,50H45l2.07-4.84H60.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.35,52.74H45a1.38,1.38,0,0,1,1.38,1.38v2.77A1.38,1.38,0,0,1,45,58.27H35.35A1.38,1.38,0,0,1,34,56.89V54.12A1.38,1.38,0,0,1,35.35,52.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.58,39.62H30.51a.69.69,0,0,1,0-1.38h2.07a.69.69,0,1,1,0,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41.56,42.38h-11a.69.69,0,1,1,0-1.38H41.56a.69.69,0,0,1,0,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.85,42.38H44.33a.69.69,0,1,1,0-1.38h5.52a.69.69,0,0,1,0,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.92,55.5a.69.69,0,0,1-.7-.69v-6.9a.7.7,0,0,1,1.39,0v6.9A.69.69,0,0,1,22.92,55.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.92,59a.69.69,0,0,1-.7-.69v-.69a.7.7,0,0,1,1.39,0v.69A.69.69,0,0,1,22.92,59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "99 108.88 43.52 108.88 43.52 32.26 83.15 32.26 99 48.11 99 108.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "99 48.11 83.15 48.11 83.15 32.26 99 48.11"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 48.8,
    y: 37.54,
    width: 29.06,
    height: 7.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 47.48,
    y: 49.43,
    width: 11.89,
    height: 2.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 62.01,
    y: 49.43,
    width: 2.64,
    height: 2.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 51.44,
    cy: 60,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 51.44,
    cy: 71.89,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 51.44,
    cy: 83.78,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 51.44,
    cy: 95.67,
    r: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 59.37,
    y: 56.04,
    width: 11.89,
    height: 2.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 59.37,
    y: 61.32,
    width: 5.28,
    height: 2.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 67.3,
    y: 61.32,
    width: 2.64,
    height: 2.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 59.37,
    y: 67.93,
    width: 15.85,
    height: 2.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 59.37,
    y: 79.82,
    width: 7.93,
    height: 2.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 69.94,
    y: 78.5,
    width: 2.64,
    height: 2.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 59.37,
    y: 85.1,
    width: 15.85,
    height: 2.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 59.37,
    y: 91.71,
    width: 2.64,
    height: 2.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 64.66,
    y: 91.71,
    width: 2.64,
    height: 2.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 59.37,
    y: 96.99,
    width: 10.57,
    height: 2.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 80.51,
    y: 57.36,
    width: 13.21,
    height: 13.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 80.51,
    y: 79.82,
    width: 13.21,
    height: 13.21
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "94.65 58.29 92.79 56.42 87.11 62.1 81.44 56.42 79.58 58.29 85.25 63.97 79.58 69.64 81.44 71.5 87.11 65.83 92.79 71.5 94.65 69.64 88.98 63.97 94.65 58.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "87.11 89.61 83.54 86.04 85.41 84.17 87.11 85.88 92.79 80.2 94.65 82.07 87.11 89.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "52.51 92.08 31.74 71.65 11.31 92.42 25.97 92.3 25.97 124.03 37.84 124.03 37.84 92.2 52.51 92.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "54.13 89.7 33.36 69.27 12.93 90.05 27.6 89.92 27.6 121.65 39.47 121.65 39.47 89.82 54.13 89.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M95.71,100.05v-1.3H94.42V97.46h-1.3v1.29H91.83V97.46h-1.3v1.29h-.65a.65.65,0,0,0-.64.65V102a.65.65,0,0,0,.64.65h4.54v1.29H89.24v1.3h1.29v1.29h1.3v-1.29h1.29v1.29h1.3v-1.29h.65a.65.65,0,0,0,.64-.65V102a.65.65,0,0,0-.64-.65H90.53v-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M98.37,71.39,128.75,41l4,4L102.33,75.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M98.37,71.39l-5.28,9.24,9.25-5.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122.15,47.61l6.6-6.6,4,4-6.6,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M122.7,64.78l-1.87-1.87,8.32-8.31-3-3L128,49.7l4,4a1.33,1.33,0,0,1,0,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M133.38,76.12l-3-3.08a1.08,1.08,0,0,0-1.53,0l-7,6.94-4,3.9-3-3.08a1,1,0,0,0-.76-.32,1.06,1.06,0,0,0-.77.31l-3.08,3a1.09,1.09,0,0,0,0,1.53L117,92.27a1,1,0,0,0,.76.32,1.06,1.06,0,0,0,.77-.31l3.18-3.14,11.66-11.49a1.12,1.12,0,0,0,.32-.77A1.08,1.08,0,0,0,133.38,76.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M117,92.27a1,1,0,0,0,.76.32,1.06,1.06,0,0,0,.77-.31l3.18-3.14.07-9.17-4,3.9-3-3.08a1,1,0,0,0-.76-.32,1.06,1.06,0,0,0-.77.31l-3.08,3a1.09,1.09,0,0,0,0,1.53Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevisarNominaAltaImss);
export default __webpack_public_path__ + "static/media/revisar_nomina_alta_imss.169917775615fe2ce3a3bc5debc2ec15.svg";
export { ForwardRef as ReactComponent };